import {
  Characters,
  CreateStory,
  Favorites,
  Highlights,
  Navbar,
  Overview,
} from "views/home";
import { useLibrary } from "contexts";
import { Main, Section } from "layout/Console";
import PremiumCard from "views/premium/Compact";
import { Library } from "views/library";
import { Flex } from "ui";

const HomePage = () => {
  const { loading, stories } = useLibrary();

  return (
    <Main>
      <Overview />
      <Section>
        <Highlights slides={["fox", "prince", "girl"]} />
        <Navbar />
      </Section>
      <Section title="Nuevas aventuras" subtitle="Crea tu propia historia">
        <Flex align="stretch" direction={{ xs: "column", md: "row" }}>
          <CreateStory />
          <PremiumCard />
        </Flex>
      </Section>
      <Section
        title="Cuentos destacados"
        subtitle="Mis historias favoritas"
        withoutEmptyContent
      >
        <Favorites />
      </Section>
      <Section
        title="Mi biblioteca"
        subtitle="Todos mis libros"
        link={stories.length > 0 && "/library"}
      >
        <Library orientation="landscape" limit={10} loading={loading} />
      </Section>
      <Section
        title="Mis personajes"
        subtitle="Personajes favoritos"
        withoutEmptyContent
      >
        <Characters />
      </Section>
    </Main>
  );
};

export default HomePage;
